/** @file jointMenu: the viewport's right-click menus as thin builders over the shell's menu registry. */
import type { MenuItem } from '../../state/editorTypes';
import { buildMenu } from '../../shell/menu/buildMenu';
import { treeUiOps } from '../../shell/menu/treeUiOps';
import type { ViewportCtx } from './viewportCtx';

/**
 * `node` set: the registry's joint menu (the same rows as the tree row of that node; Isolate toggles this viewport's
 * isolate). `node` null (empty space): the registry's viewport-space menu. `handlers` are the viewport's command table.
 */
export function jointMenu(ctx: ViewportCtx, node: string | null, handlers: Record<string, () => void>): MenuItem[] {
  const base = { store: ctx.store, surface: 'viewport' } as const;
  if (node === null) return buildMenu('viewport-space', { ...base, handlers, editing: ctx.mode === 'edit' });
  const isolate = { on: ctx.isolate, toggle: () => { handlers['viewport.isolate']?.(); } };
  const view = treeUiOps(ctx.store);
  return buildMenu('joint', { ...base, node, isolate, confirm: (text) => globalThis.confirm(text), ...(view === undefined ? {} : { view }) });
}
